var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPension(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 30,
    viewBox: "0 0 22 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41084 5.40413C7.41084 6.35603 7.78898 7.26894 8.46207 7.94203C9.13516 8.61512 10.0481 8.99326 11 8.99326C11.9519 8.99326 12.8648 8.61512 13.5379 7.94203C14.211 7.26894 14.5891 6.35603 14.5891 5.40413C14.5891 4.45224 14.211 3.53933 13.5379 2.86623C12.8648 2.19314 11.9519 1.815 11 1.815C10.0481 1.815 9.13516 2.19314 8.46207 2.86623C7.78898 3.53933 7.41084 4.45224 7.41084 5.40413Z",
    stroke: "#66c2ed",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 28.185L18.3146 20.8689C18.7307 20.4582 19.0614 19.9693 19.2877 19.4303C19.5141 18.8913 19.6316 18.3128 19.6335 17.7282C19.6353 17.1436 19.5216 16.5644 19.2988 16.024C19.0759 15.4835 18.7484 14.9924 18.335 14.5791C17.9216 14.1657 17.4306 13.8382 16.8901 13.6153C16.3496 13.3925 15.7704 13.2787 15.1858 13.2806C14.6012 13.2825 14.0228 13.4 13.4838 13.6263C12.9448 13.8527 12.4558 14.1834 12.0452 14.5994L11 15.6431L9.95484 14.5994C9.54415 14.1834 9.05523 13.8527 8.51622 13.6263C7.97721 13.4 7.39876 13.2825 6.81416 13.2806C6.22956 13.2787 5.65035 13.3925 5.10989 13.6153C4.56943 13.8382 4.07837 14.1657 3.665 14.5791C3.25162 14.9924 2.92408 15.4835 2.70124 16.024C2.4784 16.5644 2.36465 17.1436 2.36654 17.7282C2.36843 18.3128 2.48593 18.8913 2.71226 19.4303C2.9386 19.9693 3.26931 20.4582 3.68535 20.8689L11 28.185Z",
    stroke: "#66c2ed",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPension);
export default __webpack_public_path__ + "static/media/pension.fae1c9429ea10636ac850d40c116a35f.svg";
export { ForwardRef as ReactComponent };